const fileChLanSize: Record<string, Record<string, any>> = {};
const chMap: Record<string, string[]> = {};
const chLinks: string[] = [];
const adChMap: Record<string, any> = {};

const modules = import.meta.glob("./modules/*.ts", {
  import: "default",
  eager: true,
});
Object.keys(modules).forEach(key => {
  const filename = key.split("/").pop()?.replace(".ts", "");
  if (typeof filename === "string" && !fileChLanSize[filename]) {
    const module = modules[key] as Record<string, any>;
    if (module && typeof module === "object" && Object.keys(module).length > 0) {
      chMap[filename] = [];
      chMap[filename].push(...Object.keys(module));
      chLinks.push(...Object.keys(module));
      fileChLanSize[filename] = module;
      Object.keys(module).forEach(key => {
        adChMap[key] = module[key];
      });
    }
  }
});
if (isDevEnv || isBuildTest) {
  console.table({
    fileChLanSize,
    adChMap,
    chMap,
    chLinks,
  });
}

export { fileChLanSize, chMap, chLinks, adChMap };
